import React from 'react';
import './Footer.css';

function Footer() {
  const year = new Date().getFullYear();

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-line" />
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-mark">PP</div>
              <span>Pratik Patil</span>
            </div>
            <p className="footer-tagline">Building things that matter.</p>
          </div>

          <div className="footer-links">
            {['Home', 'About', 'Skills', 'Projects', 'Contact'].map((name) => (
              <a
                key={name}
                href={`#${name.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(name.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                {name}
              </a>
            ))}
          </div>

          <button className="scroll-top-btn" onClick={handleScrollTop} title="Back to top">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 19V5M5 12l7-7 7 7" />
            </svg>
          </button>
        </div>

        <p className="footer-copy">
          © {year} Pratik Patil. Crafted with{' '}
          <span style={{ color: '#ff6b6b' }}>❤</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
